import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { isAuthenticated, isAdmin, isLoading } = useAuth();

    if (isLoading) return <Loader message="Loading..." />;

    if (!isAuthenticated) return <Navigate to="/login" replace />;

    if (adminOnly && !isAdmin) return <Navigate to="/dashboard" replace />;

    return children;
}
